var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "image-cta-large", style: _vm.extraStyle }, [
    _c(
      "div",
      {
        staticClass:
          "d-flex flex-column flex-sm-row bg-white border border-gray-200 align-items-center rounded card-shadow card-width text-sans",
      },
      [
        _c(
          "div",
          {
            staticClass: "image-container flex-shrink-0",
            class: _vm.imageRight ? "order-sm-2" : "order-sm-0",
          },
          [
            _vm.imageUrl
              ? _c("img", {
                  staticClass: "anchor-image",
                  attrs: { src: _vm.imageUrl },
                })
              : _vm.version && _vm.presets[_vm.version].image
              ? _c(_vm.presets[_vm.version].image, { tag: "component" })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "d-flex flex-column flex-grow-1 p-3 px-sm-4 justify-content-center text-center order-1",
          },
          [
            _c(
              "h5",
              { staticClass: "mx-3 mb-3 mb-lg-4 text-serif" },
              [
                _vm.headline
                  ? _c("span", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.headline) +
                          "\n                "
                      ),
                    ])
                  : _vm.version && _vm.presets[_vm.version].headline
                  ? _c("span", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.presets[_vm.version].headline) +
                          "\n                "
                      ),
                    ])
                  : _vm._t("default", function () {
                      return [
                        _vm._v(
                          "\n                    Find out what solar panels cost in your area in " +
                            _vm._s(_vm.currentYear) +
                            "\n                "
                        ),
                      ]
                    }),
              ],
              2
            ),
            _vm._v(" "),
            _vm.bodyHtml || (_vm.version && _vm.presets[_vm.version].body)
              ? _c("div", { staticClass: "mb-2" }, [
                  _vm.bodyHtml
                    ? _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.bodyHtml) },
                      })
                    : _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.presets[_vm.version].body),
                        },
                      }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "form",
              {
                ref: "ctaForm",
                staticClass: "mb-0 text-left",
                attrs: {
                  method: "GET",
                  action: _vm.buttonLink || _vm.presets[_vm.version].link,
                },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.validateAndSubmit.apply(null, arguments)
                  },
                },
              },
              [
                _vm.rc !== ""
                  ? _c("div", [
                      _c("input", {
                        attrs: { name: "rc", type: "hidden" },
                        domProps: { value: _vm.rc },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.zipEntry
                  ? _c("div", { staticClass: "d-block" }, [
                      _c(
                        "div",
                        { staticClass: "zip-entry-wrapper" },
                        [
                          _c("es-input", {
                            attrs: {
                              id: _vm.zipCodeInputId,
                              name: "zip_code",
                              "input-class":
                                "zip-entry bg-gray-100 border-gray-500",
                              validator: _vm.$v.zipCode,
                              placeholder: "5-digit zip code",
                              label: "Enter your zip code",
                              "bold-label": "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "afterInput",
                                  fn: function () {
                                    return [
                                      _c("location-icon", {
                                        staticClass: "location-icon",
                                        attrs: { "aria-hidden": "true" },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "validationText",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                                This field is required\n                            "
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2448721929
                            ),
                            model: {
                              value: _vm.zipCode,
                              callback: function ($$v) {
                                _vm.zipCode = $$v
                              },
                              expression: "zipCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "es-button",
                      { staticClass: "w-100", attrs: { type: "submit" } },
                      [
                        _vm.buttonText
                          ? _c("span", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.buttonText) +
                                  "\n                        "
                              ),
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.presets[_vm.version].button) +
                                  "\n                        "
                              ),
                            ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }